<template>
  <div>
    <vx-card>
      <div class="w-full">
        <vs-button type="border" size="medium" icon-pack="feather" icon="icon-plus" color="success" v-on:click="novo">Cadastrar novo</vs-button>
      </div>

      <div class="flex h-12 mt-6 fit-height">
        <div class="w-2/3 fit-height">
          <vs-table :data="users" class="fit-height">

            <template slot="thead">
              <vs-th>E-mail</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.email">
                  {{ tr.email }}
                </vs-td>

                <template class="expand-user" slot="expand">
                  <div class="con-expand-users w-full">
                    <div class="con-btns-user flex items-center justify-between">
                      <div class="flex">
                        <vs-button type="border" size="medium" icon-pack="feather" icon="icon-edit-2" color="warning" v-on:click="editar(indextr)">Editar</vs-button>
                        <vs-button type="border" size="medium" icon-pack="feather" icon="icon-trash" color="danger" class="ml-4" v-on:click="remover(indextr)">Remover</vs-button>
                      </div>
                    </div>
                  </div>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div class="w-1/3 ml-10 fit-height" v-if="mostrarForm">
          <form v-on:submit.prevent="salvar" id="formulario">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input type="email" class="w-full" icon-pack="feather" icon="at-sign" icon-no-border label-placeholder="E-mail" v-model="entrada.email" required />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input type="password" class="w-full" icon-pack="feather" icon="icon-key" icon-no-border label-placeholder="Senha" v-model="entrada.password" v-on:change="checaPassword" v-on:blur="checaPassword" required />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input type="password" class="w-full" icon-pack="feather" icon="icon-key" icon-no-border label-placeholder="Confirmação da Senha" v-model="entrada.confirmacao_password" v-on:change="checaPassword" v-on:blur="checaPassword" required />
              <span class="text-danger text-sm" v-if="!matchPassword">As senhas não conferem</span>
            </div>
          </div>
          <br />
          <div class="vx-row">
            <div class="vx-col w-full">
              <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="submit" :disabled="!matchPassword">Salvar</button>
            </div>
          </div>
        </form>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      matchPassword: true,
      entrada: {
        email: '',
        password: '',
        confirmacao_password: ''
      },
      id: '',
      mostrarForm: false,
      index: -1
    }
  },
  methods: {
    checaPassword: function() {
      if (this.entrada.password.length > 0 && (this.entrada.password != this.entrada.confirmacao_password)) {
        this.matchPassword = false;
      } else {
        this.matchPassword = true;
      }
    },
    novo: function() {
      this.entrada = {
        email: '',
        password: '',
        confirmacao_password: ''
      }
      this.index = -1;
      this.id = '';
      this.mostrarForm = true;
      this.matchPassword = true;
    },
    editar: function(index) {
      this.entrada = this.users[index];
      this.id = this.users[index]._id;
      this.index = index;
      this.mostrarForm = true;
    },
    salvar: function() {
      fetch(this.$API_URL + "/user/" + this.id, {
        method: "POST",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(this.entrada)
      })
      .then(response => response.json())
      .then(json => {

        if (json.status == 'success') {
          this.entrada = {
            email: '',
            password: '',
            confirmacao_password: ''
          }

          if (this.index != -1) {
            this.users[this.index] = json.data;
          } else {
            this.users.push(json.data)
          }

          this.mostrarForm = false;
          this.$vs.notify({
          title:'Sucesso!',
          text:'Salvo com sucesso.',
          color:'primary'})
        } else {
          this.$vs.notify({
          title:'Erro!',
          text:'Ocorreu um erro ao salvar.',
          color:'danger'})
        }
      });
    },
    getUsers: function() {
      fetch(this.$API_URL + "/user", {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
      })
      .then(response => response.json())
      .then(json => {
        json.data.forEach(entrada => {
          this.users.push(entrada)
        })
      });
    },
    remover: function(index) {
      fetch(this.$API_URL + "/user/" + this.users[index]._id, {
        method: "DELETE",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
      })
      .then(response => response.json())
      .then(json => {
        if (json.status == "success") {
          this.users.splice(index, 1);
          this.$vs.notify({
            title:'Sucesso!',
            text:'Removido com sucesso.',
            color:'primary'})
          } else {
            this.$vs.notify({
              title:'Erro!',
              text:'Ocorreu um erro ao remover.',
              color:'danger'})
          }
      });
    }
  },
  mounted() {
    this.getUsers();
  }
}
</script>

<style scoped>
  .fit-height {
    height: fit-content !important;
  }
</style>
